export default __webpack_public_path__ + "static/media/anytime.c119645e.mov";